import styled from 'styled-components'
import Slider from 'react-rangeslider'
import { WHITE, GRAY_LIGHT } from '../../theme/colors'

export const Container = styled.div`
  display: flex;
  align-items: center;

  @media (min-width: 481px) and (max-width: 1012px) {
    display: none;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    display: none;
  }

  @media only screen and (max-width: 1012px) {
    display: none;
  }
`

export const Text = styled.div`
  color: ${WHITE};
`

export const SliderContainer = styled.div`
  width: 200px;

  @media (max-width: 1524px) {
    width: 124px;
  }
`

export const StyledSlider = styled(Slider)`
  &.rangeslider-horizontal {
    height: 3px;
  }

  &.rangeslider-horizontal .rangeslider__fill {
    background-color: ${GRAY_LIGHT};
  }

  &.rangeslider-horizontal .rangeslider__handle {
    width: 18px;
    height: 18px;
  }

  &.rangeslider-horizontal .rangeslider__handle:after {
    display: none;
  }
`

export const Button = styled.div`
  user-select: none;
  cursor: pointer;
  height: 24px;
  line-height: 1;
  width: 24px;
  border-radius: 5px;
  box-shadow: 0 1px 4px 0 rgba(0,0,0,0.07);
  align-items: center;
  color: ${WHITE};
  font-size: 18px;
  font-weight: 400;
  justify-content: center;
  display: flex;
  margin: 0 10px;
  background: #4b4b4b;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ZoomSliderV1/styledComponents.tsx